let headerConfig = {
  c: [],
  shop: [],
  pdp: [],
  s: [],
  b: [],
  search: [],
  capsule: [],
  home: ['appticker'],
  sishome: [],
  notFoundPage: ['appticker', 'popuproadblock'],
  storePage: ['appticker', 'popuproadblock'],
  default: ['appticker', 'popuproadblock']
};

const entity = [
  'cart',
  'wishlist',
  'appticker',
  'search',
  'label',
  'humburger',
  'back',
  'popuproadblock'
];


function getPageType(pathname, ptype, sis) {
  let pageType;
  if (sis === true) {
    pageType = 'storePage';
  } else if (ptype === 'notFoundPage') {
    pageType = 'notFoundPage';
  } else if (pathname.includes('/c/')) {
    pageType = 'c';
  } else if (pathname.includes('/shop/')) {
    pageType = 'shop';
  } else if (pathname.includes('/s/')) {
    pageType = 's';
  } else if (pathname.includes('/p/')) {
    pageType = 'pdp';
  } else if (pathname.includes('/b/')) {
    pageType = 'b';
  } else if (pathname.includes('/search/')) {
    pageType = 'search';
  } else if (pathname.includes('/find/')) {
    pageType = 'search';
  } else if (pathname.includes('/capsule/')) {
    pageType = 'capsule';
  }  else if (pathname.includes('/order/confirm')) {
    pageType = 'orderConfirmation';
  } else if (ptype === 'HOMEPAGE' && sis) {
    pageType = 'sishome';
  } else if (ptype === 'HOMEPAGE' && !sis) {
    pageType = 'home';
  } else if (pathname.includes('/cart')) {
    pageType = 'cart';
  } else if (pathname.includes('/shipping')) {
    pageType = 'shipping';
  } else if (pathname.includes('/login')) {
    pageType = 'login';
  } else if (pathname.includes('/checkout') || pathname.includes('/retrypayment')) {
    pageType = 'checkout';
  } else if (pathname.includes('/offline')) {
    pageType = 'offline';
  } else {
    pageType = 'default';
  }
  return pageType;
}
export default function getHeaderConfigForPage(pathname, ptype, sis = false) {
  const pageType = getPageType(pathname, ptype, sis);
  const pageConfig = entity;
  headerConfig = headerConfig;
  if (headerConfig[pageType]) {
    headerConfig[pageType].forEach(removeEntity => {
      if (pageConfig.includes(removeEntity)) {
        pageConfig.splice(pageConfig.indexOf(removeEntity), 1);
      }
    });
  }
  return pageConfig;
}
